import React from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';

interface ProviderPayablesPaymentsSummaryProps {
	totalCount: number;
	totalAmount?: number;
	loading?: boolean;
}

const fmtUSD = (n: number): string => n.toLocaleString('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const ProviderPayablesPaymentsSummary = ({
	totalCount,
	totalAmount,
	loading = false,
}: ProviderPayablesPaymentsSummaryProps): JSX.Element => (
	<Paper
		elevation={0}
		sx={{
			p: 1.5,
			mb: 2,
			borderRadius: 2,
			border: '1px solid rgba(0,0,0,0.08)',
			background: 'linear-gradient(90deg, #f8f9ff 0%, #ffffff 100%)',
		}}
	>
		<Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
			<PaymentsIcon color="primary" sx={{ fontSize: 22 }} />
			<Box display="flex" alignItems="baseline" gap={2} flexWrap="wrap">
				<Typography variant="body1" fontWeight={600}>
					{loading ? (
						<Box component="span" display="inline-flex" alignItems="center" gap={1}>
							<CircularProgress size={14} />
							Cargando totales…
						</Box>
					) : (
						<>
							{totalCount} pago{totalCount !== 1 ? 's' : ''}
						</>
					)}
				</Typography>
				{!loading && totalAmount !== undefined && (
					<Typography variant="body1" color="primary.main" fontWeight={700}>
						USD {fmtUSD(totalAmount)}
					</Typography>
				)}
				{!loading && (
					<Typography variant="caption" color="text.secondary">
						según filtros aplicados
					</Typography>
				)}
			</Box>
		</Box>
	</Paper>
);
